import { FolderIdentification } from './folder-identification';

export class FolderStandByStateToggleNotification {
    public viewId: number;
    public isInStandByMode: boolean;
    public folderIdentifications: FolderIdentification[];

    public static fromJson(other: any): FolderStandByStateToggleNotification {
        const instance = new FolderStandByStateToggleNotification();
        instance.viewId = other.ViewId;
        instance.isInStandByMode = other.IsInStandByMode;
        instance.folderIdentifications = other.FolderIdentifications;
        return instance;
    }
}
